export default "__VITE_ASSET__CnDuNu92__"